export default {
    computed: {
        $_elementStyles() { return this.component.style || '' },
    }
}
